import { ActionTree } from "vuex";
import { RootState } from "../types";
import { ClientsState } from "./types";

export const actions: ActionTree<ClientsState, RootState> = {
  setRefresh({ commit }, newVal) {
    commit("SET_REFRESH", newVal);
  },
};
